import type { CasinoGame } from '@ps/web-casino-types';
import produce from 'immer';

import { TrackingCategory } from '../enums';
import { buttonClick } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent } from '../utils';

import { gameDimensions } from './gameDimensions';
import { gameEntity } from './gameEntity';

const gameEntities = (context: TrackingContextValue, game: CasinoGame, index?: number) =>
  produce(context, (draft) => {
    draft.entities = draft.entities || [];
    draft.entities.push(gameEntity(game, index));
  });

export const trackInfo = (
  context: TrackingContextValue,
  game: CasinoGame,
  index = 0,
  totalGames = 1
) => {
  GAEvent(
    { action: 'Button Pressed', label: 'Game Info' },
    { ...context, category: TrackingCategory.Casino, ...gameDimensions(game, index, totalGames) }
  );

  buttonClick({ buttonName: 'Game Info' }, gameEntities(context, game, index));
};
